<template>
  <b-container>
    <b-form>
      <b-form-group
        id="direction-name-label"
        label="ชื่อเส้นทาง"
        class="text-left"
        label-for="direction-name"
      >
        <template v-slot:label>
          ชื่อเส้นทาง
          <span
            class="text-danger"
          >
            *
          </span>
        </template>
        <b-form-input
          id="direction-name"
          v-model="itemComputed.direction"
        />
      </b-form-group>
      <div class="text-left">
        <b-button
          variant="success"
          @click="itemComputed.id ? updateHandler() : createHandler()"
        >
          {{ itemComputed.id ? 'บันทึก' : 'สร้าง' }}
        </b-button>
      </div>
    </b-form>
  </b-container>
</template>

<script>

  export default {
    name: "DirectionForm",
    props: {
      item: {
        type: Object,
        default: () => ({
          id: null,
          direction: null,
        })
      },
      createDataHandler: {
        type: Function,
        default: () => false
      },
      updateDataHandler: {
        type: Function,
        default: () => false
      },
      backHandler: {
        type: Function,
        default: () => false
      }
    },
    data() {
      return {
      }
    },
    computed: {
      itemComputed: {
        get() {
          return this.item
        },
        set(value) {
          this.$emit('update:item', value)
        }
      }
    },
    mounted() {
    },
    methods: {
      clearItem(key, value) {
        this.itemComputed[key] = value
      },
      async updateHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          await this.updateDataHandler(this.itemComputed.id, this.itemComputed, password)
        } else {
          return
        }
        this.backHandler()
      },
      async createHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          await this.createDataHandler(this.itemComputed, password)
        } else {
          return
        }
        this.backHandler()
      }
    }
  }
</script>

<style scoped>

</style>